import React from 'react'

export default function Contractors() {
    return (
        <div className='py-5' style={{ backgroundColor: 'white' }}>

            <h1 style={{fontWeight:"bold",color:'#A10302'}} className="text-center mb-5">U.S. Certified Contractors</h1>
            <div >
                <div className="container" style={{color:'grey'}}>
                    <div className="row">
                        <div className="col-12 col-md-4">
                        <div class="card" style={{ borderColor: 'white' }}>
                                <i style={{ fontSize: "100px", textAlign: 'center' }} class="fa fa-university " aria-hidden="true"></i>
                                <div class="card-body">
                                    <h5 class="card-title text-center">Government Building</h5>
                                    <p class="card-text text-center">We understand you need a building that works for
you and your organization, and it must function well.</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div class="card" style={{ borderColor: 'white' }}>
                                <i style={{ fontSize: "100px", textAlign: 'center' }} class="fa fa-hospital-o " aria-hidden="true"></i>
                                <div class="card-body">
                                    <h5 class="card-title text-center">Health Care Construction</h5>
                                    <p class="card-text text-center">We are very familiar with the challenges of creating high-quality, cost-effective health care environments.

</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                        <div class="card" style={{ borderColor: 'white' }}>
                                <i style={{ fontSize: "100px", textAlign: 'center' }} class="fa fa-beer " aria-hidden="true"></i>
                                <div class="card-body">
                                    <h5 class="card-title text-center">Water Treatment</h5>
                                    <p class="card-text text-center">The most powerful things we do is help improve
water quality for millions of people each year.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/services copy.jsx